import React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";

import { borders } from "../../theme/theme";

const DRAWER_WIDTH = 240;
const COLLAPSED_DRAWER_WIDTH = 72;

interface MenuDrawerProps {
  pathname: string;
  open: boolean;
  handleDrawerClose: () => void;
  ListComponent: React.ComponentType<{ pathname: string }>;
}

const MenuDrawer = (props: MenuDrawerProps) => {
  const { pathname, open, handleDrawerClose, ListComponent } = props;

  return (
    <Drawer
      variant="permanent"
      open={open}
      sx={{
        width: open ? DRAWER_WIDTH : COLLAPSED_DRAWER_WIDTH,
        flexShrink: 0,
        whiteSpace: "nowrap",
        boxSizing: "border-box",
        "& .MuiDrawer-paper": {
          width: open ? DRAWER_WIDTH : COLLAPSED_DRAWER_WIDTH,
          transition: (theme) =>
            theme.transitions.create("width", {
              easing: theme.transitions.easing.sharp,
              duration: open
                ? theme.transitions.duration.enteringScreen
                : theme.transitions.duration.leavingScreen,
            }),
          overflowX: "hidden",
          backgroundColor: "#fafafa",
          borderRight: "1px solid",
          borderColor: borders.light,
        },
      }}
    >
      {/* Logo / Brand Area */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: open ? "space-between" : "center",
          px: open ? 2 : 1,
          py: 1.5,
          minHeight: { xs: 56, sm: 64 },
          borderBottom: "1px solid",
          borderColor: borders.light,
        }}
      >
        {open && (
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Box
              component="img"
              src="/assets/DS-logo-full-stacked.png"
              alt="DoneStreet"
              sx={{
                height: 40,
                width: "auto",
                objectFit: "contain",
              }}
            />
          </Box>
        )}

        <IconButton
          onClick={handleDrawerClose}
          sx={{
            color: "text.secondary",
            "&:hover": {
              backgroundColor: "action.hover",
            },
          }}
        >
          <ChevronLeftIcon
            sx={{
              transition: "transform 0.2s",
              transform: open ? "rotate(0deg)" : "rotate(180deg)",
            }}
          />
        </IconButton>
      </Box>

      {/* Navigation Section */}
      <Box
        sx={{
          py: 1,
          flex: 1,
          overflowY: "auto",
          overflowX: "hidden",
        }}
      >
        <ListComponent pathname={pathname} />
      </Box>

      {/* Footer */}
      {open && (
        <Box
          sx={{
            p: 2,
            borderTop: "1px solid",
            borderColor: borders.light,
          }}
        >
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ display: "block", textAlign: "center" }}
          >
            DoneStreet v1.0
          </Typography>
        </Box>
      )}
    </Drawer>
  );
};

export default MenuDrawer;
